import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertsModalComponent } from '@app/shared/components/alerts/alerts-modal/alerts-modal.component';
import {
  AlertsService,
  AlertCategory,
  NotificationFrequency,
  NotificationChannel,
  AlertCriterion,
  AlertSettings,
  ContentsService,
  Product
} from '@vestiaire/api-sdk-angular';
import { AlertService } from '@app/shared/components/alerts/services/alert.service';
import { AlertCriterionCollection } from '@app/shared/model/classes/alert-criterion-collection';
import { isArray } from 'util';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { CreateAlertSuccess } from '@app/+product/store/actions/product.action';

@Component({
  selector: 'vc-alert-product-page-modal',
  templateUrl: './alert-product-page-modal.component.html',
  styleUrls: ['./alert-product-page-modal.component.scss']
})
export class AlertProductPageModalComponent implements OnInit {
  public product: Product;
  public listAlertFrequency;

  public sizeList: any;
  public colorList: any;
  public materialList: any;
  public substatelList: any;
  public patternList: any;
  public showPatternSelect = true;

  public errorMessage: string;

  public showForm = true;
  public showSuccess = false;
  public showAlreadyExists = false;
  public showErrors = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public datas: any,
    public dialogRef: MatDialogRef<AlertsModalComponent>,
    private alertsService: AlertsService,
    private alertStaticService: AlertService,
    private contentsService: ContentsService,
    private store$: Store<IAppState>
  ) {}

  ngOnInit() {
    this.product = this.datas.product;

    this.alertStaticService.getColorList().subscribe(
      res => {
        this.colorList = res;
      },
      () => {
        // silent catch nothing to do
      }
    );

    this.alertStaticService.getMaterialList().subscribe(
      res => {
        this.materialList = res;
      },
      () => {
        // silent catch nothing to do
      }
    );

    this.alertStaticService.getSubstateList().subscribe(
      res => {
        this.substatelList = res;
      },
      () => {
        // silent catch nothing to do
      }
    );

    this.alertStaticService.getPatternList().subscribe(
      res => {
        this.patternList = res;
      },
      () => {
        // silent catch nothing to do
      }
    );

    if (this.product && this.product.category && this.product.category.id) {
      this.contentsService.listTypeSize(this.product.category.id).subscribe(
        res => {
          if (res && res.data && isArray(res.data)) {
            this.sizeList = [];
            res.data.map(sizeRow => {
              this.sizeList.push({ id: sizeRow.idSize, label: sizeRow.nom });
            });
          }
        },
        () => {
          /* silent catch nothing to do */
        }
      );
    }
  }

  createAlert() {
    const alertCategory: AlertCategory = 'newProduct';
    const channel: Array<NotificationChannel> = [];
    const criterions: AlertCriterionCollection = new AlertCriterionCollection();
    let frequency: NotificationFrequency;

    if (this.product) {
      if (this.product.universe) {
        const universeCriterion: AlertCriterion = { key: 'idUniverse', value: [this.product.universe.id as string] };
        criterions.addCriterion(universeCriterion);
      }

      if (this.product.category.id) {
        const categoryCriterion: AlertCriterion = { key: 'idCategory', value: [this.product.category.id as string] };
        criterions.addCriterion(categoryCriterion);
      }
      if (this.product.brand) {
        const brandCriterion: AlertCriterion = { key: 'idBrand', value: [this.product.brand.id as string] };
        criterions.addCriterion(brandCriterion);
      }

      if (this.product.model) {
        const categoryCriterion: AlertCriterion = { key: 'idModel', value: [this.product.model.id as string] };
        criterions.addCriterion(categoryCriterion);
      }

      if (this.product.size) {
        const sizeCriterion: AlertCriterion = { key: 'idSize', value: [this.product.size.id as string] };
        criterions.addCriterion(sizeCriterion);
      }

      if (this.product.color) {
        const colorCriterion: AlertCriterion = { key: 'idColors', value: [this.product.color.id as string] };
        criterions.addCriterion(colorCriterion);
      }

      if (this.product.pattern) {
        const patternCriterion: AlertCriterion = { key: 'idPattern', value: [this.product.pattern.id as string] };
        criterions.addCriterion(patternCriterion);
      }

      if (this.product.material.parent) {
        const materialCriterion: AlertCriterion = {
          key: 'idMaterials',
          value: [this.product.material.parent.id as string]
        };
        criterions.addCriterion(materialCriterion);
      }

      if (this.product.material) {
        const materialCriterion: AlertCriterion = { key: 'idMaterials', value: [this.product.material.id as string] };
        criterions.addCriterion(materialCriterion);
      }
    }

    switch (this.listAlertFrequency) {
      case 'eachDay':
        frequency = 'daily';
        channel.push('email');
        break;

      case 'emailAndPush':
        frequency = 'realtime';
        channel.push('email', 'push');
        break;

      case 'email':
        frequency = 'realtime';
        channel.push('email');
        break;

      case 'push':
        frequency = 'realtime';
        channel.push('push');
        break;
    }

    const data: AlertSettings = {
      category: alertCategory,
      channels: channel,
      frequency: frequency,
      criteria: criterions.getList()
    };

    this.alertsService.createAlert(data, 'response').subscribe(
      res => {
        this.showForm = false;
        this.showSuccess = false;
        this.showAlreadyExists = false;
        this.showErrors = false;

        if (res.status === 409) {
          this.showAlreadyExists = true;
        } else if (res.status === 400 || res.status === 401) {
          this.showErrors = true;
          this.errorMessage = res['errors']['detail'];
        } else if (res.status === 201) {
          this.showSuccess = true;
          this.store$.dispatch(new CreateAlertSuccess(this.product));
        }
      },
      () => {
        // silent catch nothing to do
      }
    );
  }
}
